<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card class="cardClassDetailInfo" :noHeader="true">
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-label-text title="안전작업표준 작업명" :value="param.sopName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-label-text title="사업장" :value="param.plantName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-label-text title="단위공정" :value="param.processName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-label-text title="안전작업표준 관리번호" :value="param.sopNo"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-label-text title="작업구분" :value="param.workClassName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-label-text title="작업유형" :value="param.workTypeName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-label-text title="작업형태" :value="param.workKindName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-label-text title="위험등급" :value="param.hazardGradeName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
            <c-label-text title="제(개)정번호" :value="param.revisionNum"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
            <c-label-text title="제(개)정자" :value="param.regUserName"></c-label-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-label-text title="제(개)정일시" :value="param.regDtStr"></c-label-text>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
      <c-table
        ref="table"
        title="작업단계"
        tableId="riskHazrd02"
        :columnSetting="false"
        :usePaging="false"
        :filtering="false"
        :columns="grid.columns"
        :data="grid.data"
        @rowClick="rowClick"
      >
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
      <c-table
        ref="gridhazard"
        title="잠재위험성별 원인/결과"
        tableId="gridhazard"
        :columnSetting="false"
        :usePaging="false"
        :filtering="false"
        :columns="gridhazard.columns"
        :data="gridhazard.data"
        :isFullScreen="false"
        :merge="gridhazard.merge"
        selection="multiple"
        rowKey="mdmHazardFactorsId"
        @innerBtnClicked="innerBtnClicked"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && rowSelected" label="잠재위험성추가" icon="add" @btnClicked="addHazard" />
            <c-btn v-if="editable && rowSelected" label="저장" icon="save" @btnClicked="saveHazard" />
            <c-btn v-if="editable && rowSelected" label="삭제" icon="remove" @btnClicked="deleteHazard" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'sop-step-risk',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmSopId: '',
        plantName: '',
        sopName: '',
        sopNo: '',
        processName: '',
        hazardGradeName: '',
        workTypeName: '',
        workKindName: '',
        workClassName: '',
        revisionNum: '',
        regDtStr: '',
        regUserName: '',
        isRevPop: false,
      }),
    },
  },
  data() {
    return {
      rowSelected: false,
      selectedStepId: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '50%',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'jobStepName',
            field: 'jobStepName',
            label: '작업단계 명',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
      },
      gridhazard: {
        merge: [
          { index: 0, colName: 'riskHazardName' },
        ],
        columns: [
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '잠재위험성',
            align: 'center',
            style: 'width:26%',
            sortable: false,
            innerBtn: true,
            btns: [
              { icon: 'add', }
            ]
          },
          {
            name: 'hazardOccurReason',
            field: 'hazardOccurReason',
            label: '원인',
            align: 'left',
            style: 'width:37%',
            type: 'textarea',
            sortable: false,
          },
          {
            name: 'hazardOccurResult',
            field: 'hazardOccurResult',
            label: '결과',
            align: 'left',
            type: 'textarea',
            sortable: false,
          },
        ],
        height: '500px',
        data: [],
      },
      editable: true,
      listlUrl: '',
      detailUrl: '',
      saveUrl: '',
      deleteUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      if (this.param.isRevPop) {
        this.editable = false;
      }
      // url setting
      this.listlUrl = selectConfig.mdm.sop.step.url;
      this.detailUrl = selectConfig.mdm.sop.jobhazardreason.url;
      this.saveUrl = transactionConfig.mdm.sop.hazard.save.url;
      this.deleteUrl = transactionConfig.mdm.sop.hazard.delete.url;
      this.getList();
    },
    rowClick(row) {
      this.getDetail(row);
    },
    getList() {
      if (this.param.mdmSopId) {
        this.$http.url = this.$format(this.listlUrl, this.param.mdmSopId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      }
    },
    getDetail(row) {
      if (row) {
        this.rowSelected = true;
        this.selectedStepId = row.jobStepId;
        this.$http.url = this.detailUrl;
        this.$http.type = 'GET';
        this.$http.param = {mdmSopId: row.mdmSopId, jobStepId: row.jobStepId};
        this.$http.request((_result) => {
          this.gridhazard.data = _result.data;
        },);
      }
    },
    addHazard() {
      this.popupOptions.title = '잠재위험성 검색';
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/hazard/riskHazardPop.vue'}`);
      this.popupOptions.width = '800px';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        for(let c = 0; c < data.length; c++) {
          this.gridhazard.data.push({
            editFlag: 'C',
            mdmSopId: this.param.mdmSopId,
            jobStepId: this.selectedStepId,
            mdmHazardFactorsId: data[c].ramRiskHazardId,
            riskHazardName: data[c].riskHazardName,
            hazardOccurReason: '',
            hazardOccurResult: '',
          });
        }
      }
    },
    saveHazard() {
      let checkItem = ['riskHazardName', 'hazardOccurReason', 'hazardOccurResult']
      let isConti = true;
      this.$_.forEach(this.gridhazard.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [잠재위험성, 원인, 결과]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let saveData = this.gridhazard.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.getDetail({mdmSopId: this.param.mdmSopId, jobStepId: this.selectedStepId});
                window.getApp.$emit('ALERT', {
                  title: '안내 ', /* 안내 */
                  message: '저장되었습니다.', /* 저장되었습니다. */
                  type: 'success', // success / info / warning / error
                });
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    deleteHazard() {
      let selectData = this.$refs['gridhazard'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              this.getDetail({mdmSopId: this.param.mdmSopId, jobStepId: this.selectedStepId});
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '삭제되었습니다.', /* 삭제되었습니다. */
                type: 'success', // success / info / warning / error
              });
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    innerBtnClicked(col, props) {
      if (col.name === 'riskHazardName') {
        this.gridhazard.data.splice(props.rowIndex, 0, {
          mdmSopId: this.param.mdmSopId,
          jobStepId: this.selectedStepId,
          mdmHazardFactorsId: props.row.mdmHazardFactorsId,
          riskHazardName: props.row.riskHazardName,
          hazardOccurReason: '',
          hazardOccurResult: '',
        });
      }
    },
  }
};
</script>